import script from "./FormDepositoBase.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDepositoBase.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__